//development links

export const API_URL = process.env.REACT_APP_API_URL;
export const MEDIA_URL = process.env.REACT_APP_MEDIA_URL;
export const XMl_URL = `${process.env.REACT_APP_BASE_URL}common/api/v1/Upload/xml-to-json`;

export const END_POINTS = {
  login: "login",
  mediaUpload: "uploadFile",
  get_user: "getProfile",
  logout: "logout",
  forgotPassword: "forgotPassword",
  verifyOtp: "verifyOtp",
  resetPassword: "resetPassword",
  changePassword: "changePassword",
  uploadFiles: "uploadFiles",
  //user
  user: "user",
  getDetails: "getDetails",
  details: "details",
  //category
  category: "category",
  ////profile
  updateProfile: "updateProfile",
  getProfile: "getProfile",
  //cms
  addCms: "cms",
  getCms: "cms",
  //ads
  ads: "ads",
  //banners
  banner: "banner",
  //subscription
  subscription: "subscription",
  //settings
  settings: "setting",
  //property
  property: "property",
  propertyImport: "property/import",
  dashboard: "dashboard",
  analytics: "analytics",
  boostProfile: "boostProfile",
  propertyExport: "property/export",
  amenitiesListing: "amenities/listing",
  propertyId: "propertyId",
  //chat
  chats: "chats",
  notification: "notification",
  usersListing: "usersListing",

  export: "user/export",
  manageRevenue: "manageRevenue",
  notifyList: "notifyList",
  notifyExport: "notifyExport",
  receivedNotification: "receivedNotifications",
  amenities: "amenities",
  propertyType: "propertyType",
  propertyTypeListing: "propertyType",
  reels: "reels",
  listing: "listing",
  propertyCondition: "propertyCondition",
  feedback: "feedback-form",
  reply: "reply",
  adminRequests: "admin-requests",
  listingActionTracker: "property/listingActionTracker",

  leadsInsightPerformance: "performance-insights",
  leadsInsightGraphs: "performance-insights/leadsDetails",
  performanceInsightsOverview: "user/performance-insights/overview",
  reportProperty: "property/reportProperty",
  propertyreportPropertyById: "property/reportPropertyById",
  replyPropertyReport: "property/reportProperty",
  trackRecord: "trackRecord",
  contactUs: "contact-us",
  affiliateRequests: "affiliateRequests",
  homeDesign: "homeDesign",
  getSubscribedEmailsList: "getSubscribedEmailsList",
  claimedTransactions: "property/transactions/claim",

  //leads
  propertyLeads: "property/listing/leads",
  addLeads: "property/leads/add",
  deleteLeads: "property/leads/delete",

  //property listing for filter
  propertyListingSorted: "property/propertyListing",
  resendCreds: "user/resendLoginDetails",
  emailHistory: "emailHistory",
  getUsersListing: "user/getUsersListing",
  subscriptionHistory: "user/subscriptionHistory",
  EnquriesHistory: "contact-us/",
  temporaryToPublish: "property/temporaryUnpublish/republish",
  verification: "property/verificationRequests",
  updateVerification: "property/verificationRequests/update/",
  xmlProperties: "property/xmlProperties/listing",
  autoXmlHistory: "property/xmlHistory/company",
  exportLeads: "property/export/leads",
  refreshProperties: "user/refreshProperties",
  location: "location",
};
